module.exports = __webpack_public_path__ + "img/Bouclier04.75bf8cde.png";